<template>
    <div>
        <a-card :bordered="false"
            :tab-list="tabList"
            :active-tab-key="$route.name"
            @tabChange="change"
        >
            <span slot="tab" slot-scope="item" class="tab-header">
                <span>{{ item.name }}</span>
                {{ item.data }}
            </span>
            <router-view class="tab-view"></router-view>
        </a-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('$user', [
            'followers', 'followees', 'focusTower',
        ]),
        tabList() {
            return [
                { key: 'followee', name: '关注的人', data: `${ this.followees }` },
                { key: 'follower', name: '关注我的人', data: `${ this.followers }` },
                { key: 'focusTower', name: '关注的塔', data: `${ this.focusTower }` },
            ].map(e => ({ ...e, scopedSlots: { tab: 'tab' } }));
        },
    },
    methods: {
        change(key) {
            this.$router.push({ name: key });
        },
    }
}
</script>

<style lang="less" scoped>
.ant-card {
    background: none;
}
.tab-header {
    color: rgba(0, 0, 0, 0.45);
    font-weight: 500;
    span {
        color: rgba(0, 0, 0, 0.85);
        font-size: 16px;
    }
}
</style>